/**
 * Deploy / build metadata baked at `prebuild` into deploy-info.json → next.config env.
 * Safe on server and client (NEXT_PUBLIC_* only).
 */

const PROJECT_ID = "umpiretrack";
const GCP_REGION = "us-central1";
const CLOUD_RUN_SERVICE = "studio";
/** GitHub repo for deploy commit links (sidebar). */
const GITHUB_REPO = "aculich/umpire-empire";

export interface DeployInfo {
  commitSha: string;
  commitShort: string;
  commitIso: string;
  bundleAtIso: string;
  cloudBuildId: string;
}

export function getDeployInfo(): DeployInfo {
  return {
    commitSha: process.env.NEXT_PUBLIC_DEPLOY_COMMIT_SHA ?? "unknown",
    commitShort: process.env.NEXT_PUBLIC_DEPLOY_COMMIT_SHORT ?? "unknown",
    commitIso: process.env.NEXT_PUBLIC_DEPLOY_COMMIT_ISO ?? "",
    bundleAtIso: process.env.NEXT_PUBLIC_DEPLOY_BUNDLE_AT ?? "",
    cloudBuildId: process.env.NEXT_PUBLIC_CLOUD_BUILD_ID ?? "",
  };
}

export function formatDeployInstant(iso: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    dateStyle: "short",
    timeStyle: "medium",
  });
}

const firebaseConsoleBase = `https://console.firebase.google.com/u/0/project/${PROJECT_ID}`;
const appHostingBackendBase = `${firebaseConsoleBase}/apphosting/backends/${CLOUD_RUN_SERVICE}/locations/${GCP_REGION}`;

export const deployConsoleLinks = {
  /** Firebase Console → App Hosting (project). */
  firebaseAppHosting: `${firebaseConsoleBase}/apphosting`,
  /** Backend tabs (Studio / us-central1). */
  appHostingOverview: `${appHostingBackendBase}/overview`,
  appHostingRollouts: `${appHostingBackendBase}/rollouts`,
  appHostingLogs: `${appHostingBackendBase}/logs?time=24h`,
  appHostingUsage: `${appHostingBackendBase}/usage/current-billing`,
  cloudBuildList: `https://console.cloud.google.com/cloud-build/builds;region=${GCP_REGION}?project=${PROJECT_ID}`,
  cloudBuildDetail: (buildId: string) =>
    `https://console.cloud.google.com/cloud-build/builds/detail/${buildId};region=${GCP_REGION}?project=${PROJECT_ID}`,
  cloudRunLogs: `https://console.cloud.google.com/run/detail/${GCP_REGION}/${CLOUD_RUN_SERVICE}/logs?project=${PROJECT_ID}`,
} as const;

/** GitHub commit page for the deployed SHA (admin sidebar). */
export function githubCommitUrl(sha: string): string | null {
  const s = sha.trim();
  if (!s || s === "unknown" || !/^[a-f0-9]{7,40}$/i.test(s)) return null;
  return `https://github.com/${GITHUB_REPO}/commit/${s}`;
}
